import { DataRow } from './DataRow';

export default DataRow;
